import { render, staticRenderFns } from "./Repairs.vue?vue&type=template&id=3482e372"
import script from "./Repairs.vue?vue&type=script&lang=js"
export * from "./Repairs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports